// @ts-check

import { useMutation, useQuery } from "@tanstack/react-query"
import { useAtomValue } from "jotai"
import { useSelector } from "react-redux"
import { ChatImagesQueryOptions, ChatImagesMutationOptions } from "./query"
import { activeProjectIdAtom } from "../projects"
import { useActiveChatSessionId } from "../sessions"

function useActiveChatSessionImages() {
  // @ts-ignore
  const { user } = useSelector((state) => state.app.datastate)
  const activeProjectId = useAtomValue(activeProjectIdAtom)
  const [activeSessionId] = useActiveChatSessionId()

  return useQuery(
    ChatImagesQueryOptions.CHAT_SESSION_IMAGES({
      sessionId: activeSessionId,
      userToken: user?.userToken,
      projectId: activeProjectId,
    })
  )
}

/** @param {string} sessionId */
function useChatSessionThumbnailImage(sessionId) {
  const { user } = useSelector((state) => state.app.datastate)
  const activeProjectId = useAtomValue(activeProjectIdAtom)

  return useQuery(
    ChatImagesQueryOptions.CHAT_SESSION_THUMBNAIL_IMAGE({
      sessionId,
      userToken: user?.userToken,
      projectId: activeProjectId,
    })
  )
}

function useUploadChatSessionImage() {
  const [activeSessionId] = useActiveChatSessionId()
  const activeProjectId = useAtomValue(activeProjectIdAtom)

  return useMutation(
    ChatImagesMutationOptions.CHAT_SESSION_IMAGES({
      sessionId: activeSessionId,
      projectId: activeProjectId,
    })
  )
}

export * from "./query"
export {
  useActiveChatSessionImages,
  useChatSessionThumbnailImage,
  useUploadChatSessionImage,
}
